import {
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  d2 as copyOf,
  s9 as THROW_CCE,
  d6 as isDoubleArray,
  b4 as take,
  s5 as equals,
  l1 as List,
  e6 as isInterface,
  g7 as StringBuilder,
  f as _Char___init__impl__6a9atx,
  f1 as Collection,
  p5 as classMeta,
  e2 as copyOf_0,
  k9 as IllegalStateException,
  k6 as numberToInt,
  r6 as toString,
  j1 as LinkedHashMap,
  l9 as IndexOutOfBoundsException,
  c1 as AbstractMutableList,
  f2 as copyToArray,
  w2 as get_lastIndex,
  t2 as joinToString,
  p1 as MutableList,
  s1 as RandomAccess,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
var log2 = Math.log2;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
  }
}
class DoubleArrayList {
  constructor(capacity) {
    Companion_getInstance();
    capacity = capacity === VOID ? 7 : capacity;
    var tmp = this;
    var tmp_0 = new Float64Array(capacity);
    tmp.r33_1 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.s33_1 = 0;
  }
  o() {
    return this.s33_1;
  }
  t33(v0) {
    ensure(this, 1);
    var tmp = this.r33_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this.s33_1;
    tmp0_this.s33_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
  }
  u33(index) {
    return this.r33_1[index];
  }
  u() {
    return this.v(0);
  }
  v33(element) {
    var inductionVariable = 0;
    var last = this.s33_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.r33_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  w(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.v33((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  w33(elements) {
    var tmp0_iterator = elements.u();
    while (tmp0_iterator.h1()) {
      var e = tmp0_iterator.j1();
      if (!this.v33(e))
        return false;
    }
    return true;
  }
  x(elements) {
    return this.w33(elements);
  }
  y() {
    return this.o() === 0;
  }
  v(index) {
    return take(this.r33_1, this.s33_1).v(index);
  }
  hashCode() {
    return contentHashCode(this.r33_1, 0, this.o());
  }
  equals(other) {
    if (other instanceof DoubleArrayList)
      return this.o() === other.o() ? contentEquals(this.r33_1, other.r33_1, 0, this.o()) : false;
    if (!(other == null) ? isInterface(other, List) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = StringBuilder.f8(2 + imul(5, this.o()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.DoubleArrayList.toString.<anonymous>' call
    tmp0_also.b8(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.o();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          tmp0_also.a8(', ');
        }
        tmp0_also.z7(this.u33(n));
      }
       while (inductionVariable < last);
    tmp0_also.b8(_Char___init__impl__6a9atx(93));
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0.toString();
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    this.x33_1 = 2147483646;
    this.y33_1 = 2147483647;
    this.z33_1 = 0;
  }
}
class IntIntMap {
  constructor(nbits, loadFactor, dummy) {
    Companion_getInstance_0();
    this.a34_1 = nbits;
    this.b34_1 = loadFactor;
    this.c34_1 = 1 << this.a34_1;
    this.d34_1 = false;
    this.e34_1 = 0;
    this.f34_1 = this.c34_1 - 1 | 0;
    this.g34_1 = 1 + imul(this.a34_1, this.a34_1) | 0;
    this.h34_1 = new Int32Array(this.m34());
    this.i34_1 = new Int32Array(this.m34());
    this.j34_1 = numberToInt(this.c34_1 * this.b34_1);
    this.k34_1 = 0;
  }
  static n34(initialCapacity, loadFactor) {
    Companion_getInstance_0();
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    var tmp$ret$0;
    // Inline function 'kotlin.math.max' call
    var tmp0_max = ilog2Ceil(initialCapacity);
    tmp$ret$0 = Math.max(4, tmp0_max);
    var $this = new IntIntMap(tmp$ret$0, loadFactor, true);
    return $this;
  }
  toString() {
    return toString(this.o34());
  }
  m34() {
    return this.c34_1 + this.g34_1 | 0;
  }
  p34(out) {
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var tmp;
    if (this.d34_1) {
      Companion_getInstance_1();
      tmp = 2147483647;
    } else {
      tmp = this.q34(this.h34_1, 0);
    }
    var index = tmp;
    $l$loop: while (true) {
      var tmp_0 = index;
      Companion_getInstance_1();
      if (!!(tmp_0 === 2147483646)) {
        break $l$loop;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var tmp0_subject = index;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_1();
      if (tmp0_subject === 2147483647) {
        tmp_2 = true;
      } else {
        Companion_getInstance_1();
        tmp_2 = tmp0_subject === 2147483646;
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        tmp_1 = this.h34_1[index];
      }
      var tmp0_anonymous = tmp_1;
      // Inline function 'korlibs.datastructure.IntIntMap.toMap.<anonymous>' call
      var tmp0_anonymous_0 = this.p(tmp0_anonymous);
      // Inline function 'kotlin.collections.set' call
      out.m3(tmp0_anonymous, tmp0_anonymous_0);
      var tmp_3 = this.h34_1;
      var tmp_4;
      var tmp_5 = index;
      Companion_getInstance_1();
      if (tmp_5 === 2147483647) {
        tmp_4 = 0;
      } else {
        tmp_4 = index + 1 | 0;
      }
      index = this.q34(tmp_3, tmp_4);
    }
    return out;
  }
  o34(out, $super) {
    out = out === VOID ? linkedHashMapOf([]) : out;
    return $super === VOID ? this.p34(out) : $super.p34.call(this, out);
  }
  p(key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return 0;
    Companion_getInstance_0();
    if (index === 2147483647)
      return this.e34_1;
    return this.i34_1[index];
  }
  l34(key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this.d34_1 = true;
          this.e34_1 = value;
          var tmp0_this = this;
          var tmp1 = tmp0_this.k34_1;
          tmp0_this.k34_1 = tmp1 + 1 | 0;
          return 0;
        }
        if (this.k34_1 >= this.j34_1) {
          grow(this);
        }
        var index1 = hash1(this, key);
        var tmp = this.h34_1[index1];
        Companion_getInstance_0();
        if (tmp === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        var tmp_0 = this.h34_1[index2];
        Companion_getInstance_0();
        if (tmp_0 === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        var tmp_1 = this.h34_1[index3];
        Companion_getInstance_0();
        if (tmp_1 === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu(this);
        var last = this.h34_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp_2 = this.h34_1[n];
            Companion_getInstance_0();
            if (tmp_2 === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.g34_1 > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else {
        Companion_getInstance_0();
        if (index === 2147483647) {
          var tmp$ret$0;
          // Inline function 'kotlin.apply' call
          var tmp0_apply = this.e34_1;
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
          this.e34_1 = value;
          tmp$ret$0 = tmp0_apply;
          return tmp$ret$0;
        } else {
          var tmp$ret$1;
          // Inline function 'kotlin.apply' call
          var tmp1_apply = this.i34_1[index];
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
          this.i34_1[index] = value;
          tmp$ret$1 = tmp1_apply;
          return tmp$ret$1;
        }
      }
    }
  }
  q34(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = keys[n];
        Companion_getInstance_0();
        if (!(tmp === 0))
          return n;
      }
       while (inductionVariable < last);
    Companion_getInstance_0();
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntIntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var tmp;
    if (this.d34_1) {
      Companion_getInstance_1();
      tmp = 2147483647;
    } else {
      tmp = this.q34(this.h34_1, 0);
    }
    var index = tmp;
    $l$loop: while (true) {
      var tmp_0 = index;
      Companion_getInstance_1();
      if (!!(tmp_0 === 2147483646)) {
        break $l$loop;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var tmp0_subject = index;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_1();
      if (tmp0_subject === 2147483647) {
        tmp_2 = true;
      } else {
        Companion_getInstance_1();
        tmp_2 = tmp0_subject === 2147483646;
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        tmp_1 = this.h34_1[index];
      }
      var tmp0_anonymous = tmp_1;
      // Inline function 'korlibs.datastructure.IntIntMap.equals.<anonymous>' call
      var tmp0_anonymous_0 = this.p(tmp0_anonymous);
      if (!(other.p(tmp0_anonymous) === tmp0_anonymous_0))
        return false;
      var tmp_3 = this.h34_1;
      var tmp_4;
      var tmp_5 = index;
      Companion_getInstance_1();
      if (tmp_5 === 2147483647) {
        tmp_4 = 0;
      } else {
        tmp_4 = index + 1 | 0;
      }
      index = this.q34(tmp_3, tmp_4);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var tmp;
    if (this.d34_1) {
      Companion_getInstance_1();
      tmp = 2147483647;
    } else {
      tmp = this.q34(this.h34_1, 0);
    }
    var index = tmp;
    $l$loop: while (true) {
      var tmp_0 = index;
      Companion_getInstance_1();
      if (!!(tmp_0 === 2147483646)) {
        break $l$loop;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var tmp0_subject = index;
      var tmp_1;
      var tmp_2;
      Companion_getInstance_1();
      if (tmp0_subject === 2147483647) {
        tmp_2 = true;
      } else {
        Companion_getInstance_1();
        tmp_2 = tmp0_subject === 2147483646;
      }
      if (tmp_2) {
        tmp_1 = 0;
      } else {
        tmp_1 = this.h34_1[index];
      }
      var tmp0_anonymous = tmp_1;
      // Inline function 'korlibs.datastructure.IntIntMap.hashCode.<anonymous>' call
      var tmp0_anonymous_0 = this.p(tmp0_anonymous);
      out = out + (tmp0_anonymous + tmp0_anonymous_0 | 0) | 0;
      var tmp_3 = this.h34_1;
      var tmp_4;
      var tmp_5 = index;
      Companion_getInstance_1();
      if (tmp_5 === 2147483647) {
        tmp_4 = 0;
      } else {
        tmp_4 = index + 1 | 0;
      }
      index = this.q34(tmp_3, tmp_4);
    }
    return out;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.r34_1 = 2147483646;
    this.s34_1 = 2147483647;
    this.t34_1 = 0;
  }
}
class Mixin {
  constructor(extra) {
    extra = extra === VOID ? null : extra;
    this.u34_1 = extra;
  }
}
class FastArrayList extends AbstractMutableList {
  static x34(__array) {
    var $this = super.n2();
    $this.w34_1 = __array;
    return $this;
  }
  static y34() {
    var tmp$ret$0;
    // Inline function 'kotlin.emptyArray' call
    tmp$ret$0 = [];
    var $this = this.x34(tmp$ret$0);
    return $this;
  }
  o() {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.w34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2.length;
  }
  p(index) {
    var tmp$ret$4;
    // Inline function 'korlibs.datastructure.get' call
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.w34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp0_get = tmp$ret$2;
    var tmp1_get = rangeCheck(this, index);
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = tmp0_get;
    tmp$ret$4 = tmp$ret$3[tmp1_get];
    return tmp$ret$4;
  }
  z(index, element) {
    rangeCheck(this, index);
    var tmp$ret$9;
    // Inline function 'kotlin.apply' call
    var tmp$ret$4;
    // Inline function 'korlibs.datastructure.get' call
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.w34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp0_get = tmp$ret$2;
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = tmp0_get;
    tmp$ret$4 = tmp$ret$3[index];
    var tmp1_apply = tmp$ret$4;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FastArrayList.set.<anonymous>' call
    // Inline function 'korlibs.datastructure.set' call
    var tmp$ret$7;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$6;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast_0 = this.w34_1;
    var tmp$ret$5;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$5 = tmp0_unsafeCast_0;
    tmp$ret$6 = tmp$ret$5;
    tmp$ret$7 = tmp$ret$6;
    var tmp0_set = tmp$ret$7;
    var tmp$ret$8;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$8 = tmp0_set;
    tmp$ret$8[index] = element;
    tmp$ret$9 = tmp1_apply;
    return tmp$ret$9;
  }
  e1(element) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.w34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp$ret$2.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this.z1_1;
    tmp0_this.z1_1 = tmp1 + 1 | 0;
    return true;
  }
  o2(index, element) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.w34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp$ret$2.splice(insertionRangeCheck(this, index), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this.z1_1;
    tmp0_this.z1_1 = tmp1 + 1 | 0;
  }
  k1(elements) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp$ret$0 = copyToArray(elements);
    return _addAll(this, tmp$ret$0);
  }
  a2(index) {
    rangeCheck(this, index);
    var tmp0_this = this;
    var tmp1 = tmp0_this.z1_1;
    tmp0_this.z1_1 = tmp1 + 1 | 0;
    var tmp2_subject = index;
    var tmp;
    if (tmp2_subject === 0) {
      var tmp$ret$2;
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_unsafeCast = this.w34_1;
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_unsafeCast;
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$2 = tmp$ret$1;
      tmp = tmp$ret$2.shift();
    } else if (tmp2_subject === get_lastIndex(this)) {
      var tmp$ret$5;
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      var tmp$ret$4;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_unsafeCast_0 = this.w34_1;
      var tmp$ret$3;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$3 = tmp0_unsafeCast_0;
      tmp$ret$4 = tmp$ret$3;
      tmp$ret$5 = tmp$ret$4;
      tmp = tmp$ret$5.pop();
    } else {
      var tmp$ret$10;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$8;
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      var tmp$ret$7;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_unsafeCast_1 = this.w34_1;
      var tmp$ret$6;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$6 = tmp0_unsafeCast_1;
      tmp$ret$7 = tmp$ret$6;
      tmp$ret$8 = tmp$ret$7;
      var tmp0_unsafeCast_2 = tmp$ret$8.splice(index, 1);
      var tmp$ret$9;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$9 = tmp0_unsafeCast_2;
      tmp$ret$10 = tmp$ret$9;
      tmp = tmp$ret$10[0];
    }
    return tmp;
  }
  f1(element) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.w34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var array = tmp$ret$2;
    var inductionVariable = 0;
    var last = array.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$4;
        // Inline function 'korlibs.datastructure.get' call
        var tmp$ret$3;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = array;
        tmp$ret$4 = tmp$ret$3[index];
        if (equals(tmp$ret$4, element)) {
          array.splice(index, 1);
          var tmp1_this = this;
          var tmp2 = tmp1_this.z1_1;
          tmp1_this.z1_1 = tmp2 + 1 | 0;
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  }
  s2(fromIndex, toIndex) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.w34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp$ret$2.splice(fromIndex, toIndex - fromIndex | 0);
    var tmp0_this = this;
    var tmp1 = tmp0_this.z1_1;
    tmp0_this.z1_1 = tmp1 + 1 | 0;
  }
  n1() {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.w34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp$ret$2.length = 0;
    var tmp0_this = this;
    var tmp1 = tmp0_this.z1_1;
    tmp0_this.z1_1 = tmp1 + 1 | 0;
  }
  q2(element) {
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.w34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2.indexOf(element);
  }
  toString() {
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.w34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp0_unsafeCast_0 = tmp$ret$2;
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = tmp0_unsafeCast_0;
    tmp$ret$4 = tmp$ret$3;
    return '[' + joinToString(tmp$ret$4, ', ') + ']';
  }
  k4() {
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = this.w34_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    var tmp0_unsafeCast_0 = tmp$ret$2.concat();
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = tmp0_unsafeCast_0;
    tmp$ret$4 = tmp$ret$3;
    return tmp$ret$4;
  }
  toArray() {
    return this.k4();
  }
}
class NonRecursiveLock {}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function ensure($this, count) {
  if (($this.s33_1 + count | 0) > $this.r33_1.length) {
    var tmp = $this;
    var tmp_0 = $this.r33_1;
    var tmp$ret$0;
    // Inline function 'kotlin.math.max' call
    var tmp0_max = $this.s33_1 + count | 0;
    var tmp1_max = imul($this.r33_1.length, 3);
    tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
    var tmp_1 = copyOf(tmp_0, tmp$ret$0);
    tmp.r33_1 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function _get_stashStart__3psegu($this) {
  return $this.h34_1.length - $this.g34_1 | 0;
}
function grow($this) {
  var inc = $this.a34_1 < 20 ? 3 : 1;
  var newnbits = $this.a34_1 + inc | 0;
  var new_0 = new IntIntMap(newnbits, $this.b34_1, true);
  var inductionVariable = 0;
  var last = $this.h34_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.h34_1[n];
      Companion_getInstance_0();
      if (!(k === 0)) {
        new_0.l34(k, $this.i34_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.a34_1 = new_0.a34_1;
  $this.c34_1 = new_0.c34_1;
  $this.f34_1 = new_0.f34_1;
  $this.g34_1 = new_0.g34_1;
  $this.h34_1 = new_0.h34_1;
  $this.i34_1 = new_0.i34_1;
  $this.j34_1 = new_0.j34_1;
}
function growStash($this) {
  $this.g34_1 = imul($this.g34_1, 2);
  $this.h34_1 = copyOf_0($this.h34_1, $this.m34());
  $this.i34_1 = copyOf_0($this.i34_1, $this.m34());
}
function _getKeyIndex($this, key) {
  if (key === 0) {
    var tmp;
    if ($this.d34_1) {
      Companion_getInstance_0();
      tmp = 2147483647;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  var index1 = hash1($this, key);
  if ($this.h34_1[index1] === key)
    return index1;
  var index2 = hash2($this, key);
  if ($this.h34_1[index2] === key)
    return index2;
  var index3 = hash3($this, key);
  if ($this.h34_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu($this);
  var last = $this.h34_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.h34_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot($this, index, key, value) {
  var tmp = $this.h34_1[index];
  Companion_getInstance_0();
  if (!(tmp === 0))
    throw IllegalStateException.we();
  $this.h34_1[index] = key;
  $this.i34_1[index] = value;
  $this.k34_1 = $this.k34_1 + 1 | 0;
  return 0;
}
function hash1($this, key) {
  return _hash1(key, $this.f34_1);
}
function hash2($this, key) {
  return _hash2(key, $this.f34_1);
}
function hash3($this, key) {
  return _hash3(key, $this.f34_1);
}
function _hash1(key, mask) {
  return _mask(key, mask);
}
function _hash2(key, mask) {
  return _mask(imul(key, 1294968109), mask);
}
function _hash3(key, mask) {
  return _mask(imul(key, 294969449), mask);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function _mask(value, mask) {
  return (((value + ((value >>> 8 | 0) & 255) | 0) + ((value >>> 16 | 0) & 255) | 0) + (value >> 24 & 255) | 0) & mask;
}
function linkedHashMapOf(pairs) {
  // Inline function 'kotlin.also' call
  var tmp0_also = LinkedHashMap.n8();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.linkedHashMapOf.<anonymous>' call
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var tmp1_loop_parameter = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var key = tmp1_loop_parameter.ti();
    var value = tmp1_loop_parameter.ui();
    // Inline function 'kotlin.collections.set' call
    tmp0_also.m3(key, value);
  }
  return tmp0_also;
}
function ilog2Ceil(v) {
  var tmp$ret$1;
  // Inline function 'kotlin.math.ceil' call
  // Inline function 'kotlin.math.log2' call
  var tmp1_ceil = log2(v);
  tmp$ret$1 = Math.ceil(tmp1_ceil);
  return numberToInt(tmp$ret$1);
}
function contentHashCode(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var tmp0_hashCoder = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < tmp0_hashCoder)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < tmp0_hashCoder);
  return out;
}
function contentEquals(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var tmp0_equaler = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_equaler)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < tmp0_equaler);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function _addAll($this, elements) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (elements.length === 0)
    return false;
  var tmp$ret$3;
  // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp$ret$3 = $this.w34_1;
  (function () {
    var $externalVarargReceiverTmp = tmp$ret$3;
    return $externalVarargReceiverTmp.push.apply($externalVarargReceiverTmp, [].slice.call(elements.slice()));
  }.call(this));
  $this.z1_1 = $this.z1_1 + 1 | 0;
  return true;
}
function rangeCheck($this, index) {
  if (index < 0 ? true : index >= $this.o())
    throw IndexOutOfBoundsException.t('index: ' + index + ', size: ' + $this.o());
  return index;
}
function insertionRangeCheck($this, index) {
  if (index < 0 ? true : index > $this.o())
    throw IndexOutOfBoundsException.t('index: ' + index + ', size: ' + $this.o());
  return index;
}
function FastStringMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
var CONCURRENCY_COUNT;
//region block: post-declaration
setMetadataFor(Companion, 'Companion', objectMeta);
setMetadataFor(DoubleArrayList, 'DoubleArrayList', classMeta, VOID, [Collection]);
setMetadataFor(Companion_0, 'Companion', objectMeta);
setMetadataFor(IntIntMap, 'IntIntMap', classMeta);
setMetadataFor(Companion_1, 'Companion', objectMeta);
setMetadataFor(Mixin, 'Mixin', classMeta);
setMetadataFor(FastArrayList, 'FastArrayList', classMeta, VOID, [AbstractMutableList, MutableList, RandomAccess]);
setMetadataFor(NonRecursiveLock, 'NonRecursiveLock', classMeta);
//endregion
//region block: init
CONCURRENCY_COUNT = 1;
//endregion
//region block: exports
export {
  NonRecursiveLock as a,
  DoubleArrayList as b,
  Mixin as c,
  FastArrayList as d,
  FastStringMap as e,
  IntIntMap as f,
  linkedHashMapOf as g,
};
//endregion

//# sourceMappingURL=korge-root-kds.mjs.map
